import type { CrmPipeline } from '@integrations/crm-pipelines/contracts/crm-pipeline.contract';

import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { retryTransient } from '@integrations/shared/retry-policy';

import { CrmPipelinesApiService } from '../api/crm-pipelines-api.service';

export const CRM_PIPELINES_QUERY_KEY = ['crm-pipelines'] as const;

type CrmPipelinesQueryOverrides = Partial<Omit<CreateQueryOptions<CrmPipeline[]>, 'queryKey' | 'queryFn'>>;

export function injectCrmPipelinesQuery(optionsFn?: () => CrmPipelinesQueryOverrides) {
    const api = inject(CrmPipelinesApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        // A definitive 4xx is how "the account does not have this" is detected, so it must
        // not be retried; a transient failure gets a few attempts instead of being mistaken
        // for that answer (#71534).
        retry: retryTransient,
        queryKey: CRM_PIPELINES_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getPipelinesList()),
        ...optionsFn?.(),
    }));
}
